(function (angular) {
    angular
        .module('one.admin.config')
        .config(config);

    config.$inject = ['config'];

    function config(config) {
        config.minSearchLength = 2;
    }
})(angular);
